import { render, staticRenderFns } from "./BriocheImageTag.vue?vue&type=template&id=7c9fda2f&"
import script from "./BriocheImageTag.vue?vue&type=script&lang=ts&"
export * from "./BriocheImageTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c9fda2f', component.options)
    } else {
      api.reload('7c9fda2f', component.options)
    }
    module.hot.accept("./BriocheImageTag.vue?vue&type=template&id=7c9fda2f&", function () {
      api.rerender('7c9fda2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/BriocheImageTag.vue"
export default component.exports